<template>
  <div>
    <el-card shadow="always">
      <el-page-header title="Home" @back="$router.replace({ name: 'home' })"
        :content="$t('log-notificacao')"></el-page-header>
    </el-card>
    <br />
    <el-card>
      <el-form :model="ruleForm" ref="ruleForm" label-position="top">
        <el-row :gutter="5">
          <el-col :span="12">
            <el-form-item :label="$t('etiqueta')" prop="tag">
              <el-input ref="tag" v-model="ruleForm.tag"></el-input>
          </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('telefone')" prop="phone">
              <el-input ref="phone" v-model="ruleForm.phone" v-mask="['(##) #####-####', '(##) #####-####']"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item>
          <el-button type="warning" autofocus @click="fetchRecords">{{
            $t("pesquisar")
          }}</el-button>
        </el-form-item>
      </el-form>
      <br />
      <el-table :data="tableData" stripe style="width: 100%">
        <el-table-column prop="createdAt" :label="$t('data')" />
        <el-table-column prop="tag" :label="$t('etiqueta')" />
        <el-table-column prop="phone" :label="$t('telefone')"></el-table-column>
        <el-table-column prop="status" :label="$t('status')">
          <template slot-scope="scope">
           {{ scope.row.status ? scope.row.status.message : '' }}
        </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>
<script>
import { UserService } from "@/services/users/user.services";
import { NotificationService } from "@/services/comum/notification.services";

import { i18n } from "@/plugin/i18n";

export default {
  name: "NotificationLog",
  data() {
    return {
      ruleForm: {
        tag: "",
        phone: "",
      },
      userType: "1",
      tableData: [],
    };
  },
  methods: {
    fetchRecords() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);

      NotificationService.logs(vm.ruleForm.tag, vm.ruleForm.phone)
        .then((response) => {
          vm.tableData = response;
        })
        .catch((error) => {
          vm.$notify.error({
            title: i18n.tc("erro"),
            message: error,
          });
        })
        .finally(() => loading.close());
    },
  },
  mounted() {
    const vm = this;
    UserService.me()
      .then((response) => {
        vm.userType = response.type;
      })
      .catch(() => {
        vm.$message({
          type: "error",
          message: "Usuário sem acesso a essa função",
        });
      });
  },
};
</script>
<style>
.right {
  float: right;
}

.label {
  font-weight: bold;
}
</style>